"use client";
import { motion } from "framer-motion";

export default function Story() {
  const stats = [
    { n: "3,000+", label: "Assignments analysed" },
    { n: "90%", label: "Predicted grade accuracy" },
    { n: "48 hrs", label: "Avg. time saved per submission" },
  ];

  return (
    <section className="py-20 md:py-32 bg-background">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-8"
        >
          <p className="text-[11px] font-mono uppercase tracking-[0.18em] text-muted-foreground mb-6">
            Why We Built This
          </p>
          <div className="border-t border-border" />
        </motion.div>

        <motion.blockquote
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.08 }}
          viewport={{ once: true }}
          className="mt-12 md:mt-16 text-2xl md:text-4xl lg:text-[2.6rem] font-bold leading-[1.2] tracking-tight text-foreground max-w-4xl"
        >
          "Bro, I failed this assignment, and I really don't know what
          to do. I've even called my parents about my convocation."
        </motion.blockquote>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.14 }}
          viewport={{ once: true }}
          className="mt-5 text-sm text-muted-foreground font-mono"
        >
          — Arisha, sent at 11:47 pm the night before results
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.18 }}
          viewport={{ once: true }}
          className="mt-14 md:mt-20 text-lg md:text-xl text-muted-foreground leading-relaxed max-w-xl"
        >
          No student should submit blindly and wait in dread.
          We built AssignOwl so you know exactly where you stand —
          before the grade comes back.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.22 }}
          viewport={{ once: true }}
          className="mt-16 md:mt-24 pt-10 md:pt-12 border-t border-border grid grid-cols-3"
        >
          {stats.map((s, i) => (
            <div
              key={i}
              className={[
                i === 0 ? "pr-6 md:pr-10" : "",
                i === 1 ? "px-6 md:px-10 border-l border-border" : "",
                i === 2 ? "pl-6 md:pl-10 border-l border-border" : "",
              ].join(" ")}
            >
              <div className="text-3xl md:text-4xl font-bold text-foreground mb-1.5">
                {s.n}
              </div>
              <div className="text-sm text-muted-foreground">{s.label}</div>
            </div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}
